import { default as domainTypeSubscription } from './type-subscription/services'
import { default as domainTypeProcess } from './type-process/services'
import { default as domainDocumentType } from './document-type/services'
import { default as domainGroupSubscriber } from './group-subscriber/services'
import { default as domainUserSubscriber } from './user-subscriber/services'

export default { 
	domainTypeSubscription,
	domainTypeProcess,
	domainDocumentType,
	domainGroupSubscriber,
	domainUserSubscriber
}
